<template>
    <div class="nc-detail">

        <div class="nc-detail__top">

            <div v-if="chat.operator_in_work" class="nc-detail__row">
                <span class="nc-detail__label">Ответственный оператор:</span>
                <span class="nc-detail__value">{{ chat.operator_in_work }}</span>
            </div>

            <new-chat-drivers v-if="drivers.length" :drivers="drivers" />

            <div class="nc-detail__row">
                <span class="nc-detail__label">Номер:</span>
                <span class="nc-detail__value">{{ chat.phone }}</span>
            </div>

            <div class="nc-detail__row">
                <span class="nc-detail__label">Сообщения:</span>
                <span class="nc-detail__value">
                    {{ chat.count.total }} всего<template v-if="chat.count.unread">, {{ chat.count.unread }} непрочитано</template>
                </span>
            </div>

            <new-chat-expandable-field
                v-if="departments.length"
                label="Департамент"
                :value="selectedDepartmentId"
                :value-name="currentDepartmentName"
                add-placeholder="Выберите департамент"
                :list="departments"
                select-placeholder="Выберите департамент"
                :loading="isChangingDept"
                button-text="Перевести"
                @confirm="handleChangeDepartment"
            />

            <new-chat-expandable-field
                v-if="categories.length && !chat.can_assign"
                label="Категория"
                :value="selectedCategoryId"
                :value-name="currentCategoryName"
                add-placeholder="Добавить категорию"
                :list="categories"
                select-placeholder="Выберите категорию"
                :loading="isSettingCategory"
                button-text="Установить категорию"
                @confirm="handleSetCategory"
            />

            <div class="nc-detail__row">
                <v-button
                    v-if="chat.can_assign"
                    size="full-width"
                    class="button_size_medium button_color_black"
                    :loading="isActioning"
                    :disabled="isActioning"
                    @click="handleAssign"
                >
                    Взять в работу
                </v-button>
                <template v-else>
                    <v-button
                        class="button_size_medium button_color_white nc-detail__action-btn"
                        :loading="isActioning"
                        :disabled="isActioning || isEnding"
                        @click="handleReturn"
                    >
                        Вернуть в список
                    </v-button>
                    <v-button
                        class="button_size_medium button_color_black nc-detail__action-btn"
                        :loading="isEnding"
                        :disabled="!selectedCategoryId || isEnding || isActioning"
                        @click="handleEnd"
                    >
                        Завершить чат
                    </v-button>
                </template>
            </div>

            <div  class="nc-detail__row">
                <v-button
                    size="full-width"
                    class="button_size_medium button_color_white"
                    @click="showHistory = true"
                >
                    Загрузить предыдущие сообщения
                </v-button>
            </div>

        </div>

        <new-chat-history-panel
            v-if="showHistory && chat.customer_id"
            :customer-id="chat.customer_id"
            :chat-id="chat.id"
            @close="showHistory = false"
        />

        <new-chat-messenger />

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import api from '@api'
import vButton from '../../global/vButton.vue'
import NewChatMessenger from '../messenger/NewChatMessenger.vue'
import NewChatHistoryPanel from '../messenger/NewChatHistoryPanel.vue'
import NewChatExpandableField from './NewChatExpandableField.vue'
import NewChatDrivers from './NewChatDrivers.vue'

export default {
    name: 'NewChatDetail',
    components: {
        vButton,
        NewChatMessenger,
        NewChatHistoryPanel,
        NewChatExpandableField,
        NewChatDrivers,
    },
    props: {
        chat: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedDepartmentId: this.chat.department_id || '',
            selectedCategoryId:   this.chat.category_id || '',
            drivers: [],
            isActioning:          false,
            isEnding:             false,
            isChangingDept:       false,
            isSettingCategory:    false,
            showHistory:          false,
        }
    },
    computed: {
        ...mapGetters('newChat', ['reference']),
        departments() {
            return (this.reference && this.reference.departments_list) ? this.reference.departments_list : []
        },
        categories() {
            return (this.reference && this.reference.categories_list) ? this.reference.categories_list : []
        },
        currentDepartmentName() {
            const item = this.departments.find(d => String(d.id) === String(this.selectedDepartmentId))
            return item ? (item.name || item.text) : ''
        },
        currentCategoryName() {
            const item = this.categories.find(c => String(c.id) === String(this.selectedCategoryId))
            return item ? (item.name || item.text) : ''
        },
    },
    mounted() {
        this.fetchMessages()
        this.fetchDrivers()
    },
    beforeDestroy() {
        this.setMessages([])
    },
    methods: {
        ...mapActions('newChat', ['setMessages', 'setMessagesLoading', 'setTotalUnread', 'setUnreadMyChats']),

        fetchDrivers() {
            api.newChat.getDriversList({ phone: this.chat.phone })
                .then(response => {
                    this.drivers = Array.isArray(response) ? response : []
                })
                .catch(err => {
                    console.error('[NewChat] drivers-list error:', err)
                })
        },
        refreshCounter() {
            api.newChat.getTotalCounter()
                .then(response => {
                    this.setTotalUnread((response.total_unread_my_chats_messages || 0) + (response.total_unread_new_chats_messages || 0))
                    this.setUnreadMyChats(response.total_unread_my_chats_messages || 0)
                })
                .catch(() => {})
        },

        fetchMessages() {
            this.setMessagesLoading(true)
            api.newChat.getMessages(this.chat.id, 1)
                .then(response => {
                    const msgs = Array.isArray(response) ? response : (response.messages || [])
                    this.setMessages(msgs)
                })
                .catch(err => {
                    console.error('[NewChat] messages error:', err)
                    this.setMessages([])
                })
                .finally(() => {
                    this.setMessagesLoading(false)
                })
        },
        handleAssign() {
            this.isActioning = true
            api.newChat.assign(this.chat.id, { phone: this.chat.phone })
                .then(() => { this.refreshCounter(); this.$emit('action', 'assign') })
                .catch(err => console.error('[NewChat] assign error:', err))
                .finally(() => { this.isActioning = false })
        },
        handleReturn() {
            this.isActioning = true
            api.newChat.returnToList(this.chat.id, { phone: this.chat.phone })
                .then(() => { this.refreshCounter(); this.$emit('action', 'return') })
                .catch(err => console.error('[NewChat] returnToList error:', err))
                .finally(() => { this.isActioning = false })
        },
        handleEnd() {
            this.isEnding = true
            api.newChat.endChat(this.chat.id, { phone: this.chat.phone })
                .then(() => { this.refreshCounter(); this.$emit('action', 'end') })
                .catch(err => console.error('[NewChat] endChat error:', err))
                .finally(() => { this.isEnding = false })
        },
        handleChangeDepartment(id) {
            this.selectedDepartmentId = id
            this.isChangingDept = true
            api.newChat.changeDepartment(this.chat.id, {
                phone:         this.chat.phone,
                department_id: id,
            })
                .then(() => { this.$emit('action', 'department') })
                .catch(err => console.error('[NewChat] changeDepartment error:', err))
                .finally(() => { this.isChangingDept = false })
        },
        handleSetCategory(id) {
            this.selectedCategoryId = id
            this.isSettingCategory = true
            api.newChat.setCategory(this.chat.id, { phone: this.chat.phone, category_id: id })
                .then(() => { this.$emit('action', 'category') })
                .catch(err => console.error('[NewChat] setCategory error:', err))
                .finally(() => { this.isSettingCategory = false })
        },
    },
}
</script>

<style lang="scss">
@import '../../../../../gulp-src/app/scss/_variables';

.nc-detail {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;

    &__top {
        border-bottom: 1px solid $global-light-gray;
        margin-bottom: 8px;
        padding-bottom: 8px;
        flex: 0 0 auto;

        .custom-select {
            width: 100%;
        }
    }

    &__action-btn {
        flex: 1 1 0;
        min-width: 0;
    }

    &__row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;

        .button {
            width: 100%;
        }

        &_field {
            cursor: pointer;
            user-select: none;
            border-radius: 8px;
            padding: 0px 6px;
            margin: 0 -4px 4px;
            transition: background 0.15s ease;

            &:hover {
                background: $global-white-f6;

                .nc-detail__field-edit {
                    opacity: 1;
                }

                .nc-detail__field-chevron {
                    color: $global-purple;
                }
            }

            &.is-open {
                background: $global-white-f6;

                .nc-detail__field-chevron {
                    color: $global-purple;
                    transform: rotate(180deg);
                }

                .nc-detail__field-edit {
                    opacity: 1;
                    color: $global-purple;
                }

                .nc-detail__field-value {
                    color: $global-purple;
                }

                .nc-detail__field-placeholder {
                    color: darken($global-purple, 10%);
                }
            }
        }
    }

    &__label {
        font-size: 14px;
        line-height: 20px;
        color: $global-gray;
        min-width: 100px;
        padding-right: 12px;
        flex: 0 0 auto;
    }

    &__value {
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        color: $global-black;
    }

    // Триггер — правая часть строки
    &__field-trigger {
        display: flex;
        align-items: center;
        gap: 4px;
        flex: 1;
        min-width: 0;
    }

    &__field-content {
        display: flex;
        align-items: center;
        gap: 5px;
        flex: 1;
        min-width: 0;
    }

    &__field-value {
        font-size: 14px;
        font-weight: 500;
        color: $global-black;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        transition: color 0.15s ease;
    }

    &__field-placeholder {
        font-size: 13px;
        color: $global-purple;
        flex: 1;
        transition: color 0.15s ease;
    }

    &__field-edit {
        flex: 0 0 auto;
        color: $global-light-gray-blue;
        opacity: 0;
        transition: opacity 0.15s ease, color 0.15s ease;
    }

    &__field-plus {
        flex: 0 0 auto;
        color: $global-purple;
    }

    &__field-chevron {
        flex: 0 0 14px;
        color: $global-light-gray-blue;
        transition: transform 0.26s cubic-bezier(0.4, 0, 0.2, 1), color 0.15s ease;
    }

    // Раскрывающаяся панель
    &__panel {
        background: $global-white-f6;
        border: 1px solid $global-light-gray;
        border-radius: 10px;
        padding: 10px;
        margin-bottom: 10px;
    }

    &__panel-row {
        &:not(:last-child) {
            margin-bottom: 8px;
        }

        .custom-select {
            width: auto;
        }
    }
}

// Fade-анимация для кнопки подтверждения
.nc-fade-enter-active,
.nc-fade-leave-active {
    transition: opacity 0.2s ease;
}
.nc-fade-enter,
.nc-fade-leave-to {
    opacity: 0;
}

.nc-detail__row .button {
  display: flex;
  flex: 1;
 height: 30px;
}

</style>